export default __webpack_public_path__ + "static/media/393.f555a06b.png";